var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('overlay-scrollbars',{ref:_vm.name,staticClass:"scrollbar-wrapper",style:({ height: _vm.height + 'px' }),attrs:{"options":{
      className: 'os-theme-thin-dark',
      scrollbars: { autoHide: 'never' }
    }}},[_vm._t("default"),_c('div',{staticClass:"v-spacer"})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }